import dayjs from 'dayjs';
import { CareCreditIntegrationCustom } from '@frontend/api-care-credit-integration';
import { numeric } from '@frontend/design-system';
import { EnrollmentFormFields } from '../widgets/care-credit-enrollment-multi-step/enrollment-multi-step.types';

/**
 *
 * Get and format data to CareCredit Standards
 */
export const getParsedEnrollmentFormFields = (fields: EnrollmentFormFields) => {
  const data: EnrollmentFormFields & { annualIncome: string; annualIncomeNumber: number } = {
    ...fields,
    dateOfBirth: fields.dateOfBirth ? dayjs(fields.dateOfBirth).format('YYYYMMDD') : '',
    phoneNumberType: CareCreditIntegrationCustom.convert.personPhoneToContactType(fields.phoneNumberType),
    amount: String(numeric(fields.amount, { decimals: 2 })),
    ssn: fields.ssn ? fields.ssn.replace(/-/g, '') : '', // remove dashes if ssn exists
    idExpirationDate: fields.idExpirationDate ? dayjs(fields.idExpirationDate).format('YYYYMMDD') : '',
    idNumber: fields.idNumber ? fields.idNumber.replace(/[-\s.]/g, '') : '', // remove formatting, spaces, slashes, etc
    annualIncome: formatAnnualIncome(fields.monthlyNetIncome),
    annualIncomeNumber: formatAnnualIncomeNumber(fields.monthlyNetIncome),
  };

  return data;
};

export const formatAnnualIncome = (monthlyNetIncome: string | number | undefined): string => {
  return String(numeric(monthlyNetIncome ? Number(monthlyNetIncome) * 12 : 0, { decimals: 2 })).replace(/,/g, '');
};

export const formatAnnualIncomeNumber = (monthlyNetIncome: string | number | undefined): number => {
  return Number(
    String(numeric(monthlyNetIncome ? Number(monthlyNetIncome) * 12 : 0, { decimals: 0 })).replace(/,/g, '')
  );
};
